import BaseStore                               from "./Base/BaseStore";
import { Gallery }                             from "../Models/Gallery/Gallery";
import { deserialize, serialize }              from "serializr";
import { createFormData }                      from "../Utils/common";
import { Container }                           from "typedi";
import AjaxService                             from "../Service/AjaxService";
import { GalleryItem }                         from "../Models/Gallery/GalleryItem";
import { observable }                          from "mobx";
import { globalPagerOptions, IPaginationData } from "../config/pagination";

export class GalleryStore extends BaseStore {
    public static readonly NAME_STORE: string = "GalleryStore";

    @observable
    private galleries: Gallery[] = [];

    @observable
    private spinner: boolean = false;

    private currentPage: number = 1;
    private pages: number       = 1;

    public getGalleries(): Gallery[] {
        return this.galleries;
    }

    public setGalleries(value: Gallery[]): this {
        this.galleries = value;

        return this;
    }

    public getPages(): number {
        return this.pages;
    }

    public setPages(value: number): this {
        this.pages = value;

        return this;
    }

    public getSpinner(): boolean {
        return this.spinner;
    }

    public setSpinner(value: boolean): this {
        this.spinner = value;

        return this;
    }

    public getCurrentPage(): number {
        return this.currentPage;
    }

    public setCurrentPage(value: number): this {
        this.currentPage = value;

        return this;
    }

    protected init() {
        this.needPersistData = false;
    }

    private getAjaxService(): AjaxService {
        return Container.get(AjaxService);
    }

    public async getPaginate(): Promise<IPaginationData<Gallery>> {
        const {data: {data: dataResponse}} = await this.getAjaxService().getPaginateGalleries(
            this.getCurrentPage(),
            globalPagerOptions.MAX_PER_PAGE
        );

        return {
            data : dataResponse.data.map((item: any) => deserialize(Gallery, item)),
            pages: dataResponse.pages
        } as IPaginationData<Gallery>;
    }

    public async getById(id: string): Promise<Gallery> {
        const {data: {data: dataResponse}} = await this.getAjaxService().getGalleryId(id);

        return deserialize(Gallery, dataResponse);
    }

    public async deleteById(id: string): Promise<boolean> {
        const {data: {success}} = await this.getAjaxService().deleteGalleryId(id);

        return success;
    }

    public async save(gallery: Gallery): Promise<Gallery> {
        const data     = serialize(gallery),
              formData = createFormData(data);

        gallery.getItems().map((galleryItem: GalleryItem, key: number) => {
            const image = galleryItem.getImageSelect() ? galleryItem.getImageSelect().file : "";
            formData.append(`images[${key}]`, image);
        });

        const {data: {data: dataResponse}} = await this.getAjaxService().saveGallery(formData);

        return deserialize(Gallery, dataResponse);
    }
}
